import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import TrackPage from "@/pages/Track";
import DonationSuccess from "@/pages/DonationSuccess";
import Symbols from "@/pages/Symbols";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";

function RouterSwitch() {
  const location = useLocation();
  // OAuth callback: Emergent returns to /#session_id=... — intercept synchronously during render.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/track/:trackId" element={<TrackPage />} />
      <Route path="/donation/success" element={<DonationSuccess />} />
      <Route path="/symbols" element={<Symbols />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.title = "PhonX — Learn to read with phonics";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouterSwitch />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
